import type { ReactNode } from 'react';
import { useAuth } from '@/stores/auth';

/**
 * Hide controls the caller's role cannot use.
 *
 * Presentation only. The server enforces the same matrix and is the real
 * control; this exists so the interface does not offer actions that will be
 * refused.
 */
export function RequirePermission({
  permission,
  children,
  fallback = null,
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const can = useAuth((s) => s.can);
  return <>{can(permission) ? children : fallback}</>;
}
